import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query SavingsCalculatorDealBrandList {
    savingsCalculatorDealBrandList {
      uuid
      name
      dealSlug
      img
      discount
    }
  }
`

export const savingsCalculatorDealBrandListQueryKey = getQueryNames(query)[0]

export default query
